(function () {
  'use strict';
  if (window.SweetweetNativeSearchPolicy) return;
  const stockKey = 'options[unavailable_products]';
  const typo = 'האפי ברתדיי';
  const canonical = 'Happy Birthday';
  function normalize(value) {
    const api = window.SweetweetSearchIntent;
    return api ? api.normalize(value) : String(value).normalize('NFKC').trim().toLowerCase().replace(/\s+/g, ' ');
  }
  function resolve(value) {
    const url = new URL(value, window.location.href);
    if (url.origin !== window.location.origin || !/\/search\/?$/.test(url.pathname)) return url;
    if (!['show', 'hide', 'last'].includes(url.searchParams.get(stockKey))) url.searchParams.set(stockKey, 'show');
    const query = url.searchParams.get('q') || '';
    const current = new URL(window.location.href);
    const originalRequested = url.searchParams.get('sw_search_original') === '1' ||
      (current.searchParams.get('sw_search_original') === '1' && current.searchParams.get('q') === query);
    if (originalRequested) {
      url.searchParams.set('sw_search_original', '1');
      url.searchParams.delete('sw_original_q');
    } else if (normalize(query) === typo) {
      url.searchParams.set('sw_original_q', query);
      url.searchParams.set('q', canonical);
    }
    return url;
  }
  function correction(value) {
    const url = new URL(value, window.location.href);
    const original = url.searchParams.get('sw_original_q');
    if (!original || normalize(original) !== typo || url.searchParams.get('q') !== canonical) return null;
    const note = document.createElement('div');
    note.className = 'sw-search-correction';
    note.setAttribute('role', 'status');
    note.dataset.swCorrectionUrl = url.href;
    note.append(document.createTextNode('מציגים תוצאות עבור Happy Birthday במקום ״' + original + '״.'));
    const originalUrl = new URL(url.href);
    originalUrl.searchParams.set('q', original);
    originalUrl.searchParams.set('sw_search_original', '1');
    originalUrl.searchParams.delete('sw_original_q');
    originalUrl.searchParams.delete('page');
    const link = document.createElement('a');
    link.href = originalUrl.href;
    link.textContent = 'חיפוש הביטוי המקורי ללא תיקון';
    note.append(link);
    return note;
  }
  window.SweetweetNativeSearchPolicy = { resolve: resolve, correction: correction };
  function hidden(form, name, value) {
    let input = Array.from(form.elements).find(el => el.name === name);
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
    input.value = value;
  }
  function isSearch(form) {
    return form && form.matches('form.search-form,form.search-page-form,form.cc-facet-filters') &&
      form.querySelector('[name="q"]') && (!form.matches('.cc-facet-filters') || /\/search\/?$/.test(location.pathname));
  }
  function boot() {
    const current = new URL(location.href);
    document.querySelectorAll('form.search-form,form.search-page-form,form.cc-facet-filters').forEach(form => {
      if (!isSearch(form)) return;
      const isPageForm = !form.matches('.search-form');
      if (isPageForm && !form.dataset.swStockChoice && ['hide', 'show', 'last'].includes(current.searchParams.get(stockKey))) hidden(form, stockKey, current.searchParams.get(stockKey));
      else if (!form.querySelector('[name="' + stockKey + '"]')) hidden(form, stockKey, 'show');
      if (isPageForm && form.querySelector('[name="q"]').value === current.searchParams.get('q')) {
        ['sw_original_q', 'sw_search_original'].forEach(key => { if (current.searchParams.has(key)) hidden(form, key, current.searchParams.get(key)); });
      }
    });
    const stockChoice = document.querySelector('.sw-search-stock-choice input');
    if (stockChoice && current.searchParams.get(stockKey) === 'hide' && !stockChoice.dataset.swInitialized) { stockChoice.checked = true; stockChoice.dataset.swInitialized = 'true'; }
    const slot = document.querySelector('.search-performed');
    if (slot) {
      const existing = slot.querySelector('.sw-search-correction');
      if (!existing || existing.dataset.swCorrectionUrl !== current.href) {
        const note = correction(current.href);
        if (existing) existing.remove();
        if (note) slot.prepend(note);
      }
    }
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches('.sw-search-stock-choice input')) { event.target.form.dataset.swStockChoice = 'true'; hidden(event.target.form, stockKey, 'show'); event.target.form.requestSubmit(); }
  });
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!isSearch(form)) return;
    const url = new URL(form.getAttribute('action') || location.pathname, location.href);
    const data = new FormData(form);
    url.search = new URLSearchParams(data).toString();
    const submittedHref = url.href;
    const q = url.searchParams.get('q') || '';
    if (q !== new URL(location.href).searchParams.get('q')) {
      url.searchParams.delete('sw_search_original');
      url.searchParams.delete('sw_original_q');
    }
    const next = resolve(url.href);
    if (next.href !== submittedHref) { event.preventDefault(); location.assign(next.href); }
  }, true);
  function start() {
    const current = new URL(location.href);
    if (/\/search\/?$/.test(current.pathname) && current.searchParams.has('q')) {
      const next = resolve(current.href);
      if (next.href !== current.href) { location.replace(next.href); return; }
    }
    boot();
    let queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; boot(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
